"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var React = require("react");

var MdHelp_1 = require("@react-icons/all-files/md/MdHelp");

var styled_components_1 = require("styled-components");

var react_transition_group_1 = require("react-transition-group");

var react_use_1 = require("react-use");

var Clickable_1 = require("./Clickable");

var utils_1 = require("../utils");

var ICON_SIZE = 16;
var POPOUT_GAP_SIZE = 10;
var MARKER_POSITIONS = {
  top: "\n    top: 100%;\n    left: 0;\n    right: 0;\n  ",
  bottom: "\n    transform: rotate(180deg);\n    bottom: 100%;\n    left: 0;\n    right: 0;\n  ",
  left: "\n    transform: rotate(-90deg);\n    left: 100%;\n    top: 0;\n    bottom: 0;\n  ",
  right: "\n    transform: rotate(90deg);\n    right: 100%;\n    top: 0;\n    bottom: 0;\n  "
};
var POPOUT_POSITIONS = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};

var calculateTopOrBottom = function calculateTopOrBottom(pos, yOffset) {
  var addGap = POPOUT_GAP_SIZE + yOffset;
  var position = POPOUT_POSITIONS[pos];
  return "\n    " + position + ": " + addGap + "px;\n  ";
};

var calculateLeftOrRight = function calculateLeftOrRight(pos, xOffset) {
  if (pos === 'left') {
    return "\n      right: " + xOffset + "px;\n    ";
  }

  return "\n    left: " + xOffset + "px;\n  ";
};

var TRANSITION_STYLES = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
var TooltipPopout = styled_components_1.default.div(function (_a) {
  var colors = _a.theme.colors,
      themeStyles = _a.themeStyles,
      position = _a.position,
      transitionState = _a.transitionState,
      xOffset = _a.xOffset,
      yOffset = _a.yOffset;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      line-height: 16px;\n      padding: 8px;\n      transition: opacity 0.2s ease-out;\n      z-index: 99;\n      text-align: center;\n      white-space: nowrap;\n\n      ", "\n      ", "\n\n      position: absolute;\n      border-radius: 6px;\n      font-size: 13px;\n\n      &::after {\n        ", "\n        content: ' ';\n        position: absolute;\n        margin: auto;\n        height: 1px;\n        width: 1px;\n        border-width: 5px;\n        border-style: solid;\n        border-color: ", "\n          transparent transparent transparent;\n      }\n\n      ", "\n      ", "\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n      line-height: 16px;\n      padding: 8px;\n      transition: opacity 0.2s ease-out;\n      z-index: 99;\n      text-align: center;\n      white-space: nowrap;\n\n      ", "\n      ", "\n\n      position: absolute;\n      border-radius: 6px;\n      font-size: 13px;\n\n      &::after {\n        ", "\n        content: ' ';\n        position: absolute;\n        margin: auto;\n        height: 1px;\n        width: 1px;\n        border-width: 5px;\n        border-style: solid;\n        border-color: ", "\n          transparent transparent transparent;\n      }\n\n      ", "\n      ", "\n    "])), colors.base, colors.greyLighter, calculateLeftOrRight(position, xOffset), calculateTopOrBottom(position, yOffset), MARKER_POSITIONS[position], themeStyles.backgroundColor || colors.greyLighter, themeStyles, TRANSITION_STYLES[transitionState]);
});
var TooltipReference = styled_components_1.default(function (_a) {
  var isClick = _a.isClick,
      rest = __rest(_a, ["isClick"]);

  return React.createElement(Clickable_1.Clickable, __assign({}, rest));
})(function (_a) {
  var fullWidth = _a.fullWidth,
      isClick = _a.isClick;
  return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n  "])), isClick ? "cursor: pointer;" : '', fullWidth ? "width: 100%" : '');
});
var Icon = styled_components_1.default(MdHelp_1.MdHelp)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (p) {
  return p.theme.colors.primary;
});

function Tooltip(_a) {
  var _b = _a.yOffset,
      yOffset = _b === void 0 ? 0 : _b,
      _c = _a.xOffset,
      xOffset = _c === void 0 ? 0 : _c,
      _d = _a.position,
      position = _d === void 0 ? 'top' : _d,
      children = _a.children,
      action = _a.action,
      trigger = _a.trigger,
      _e = _a.variant,
      variant = _e === void 0 ? 'light' : _e,
      size = _a.size,
      className = _a.className;
  var isClick = action === 'click';
  var tooltipReferenceRef = React.useRef(null);
  var tooltipPopoutRef = React.useRef(null);

  var _f = react_use_1.useToggle(false),
      isVisibleByClick = _f[0],
      toggleClickVisible = _f[1];

  var theme = styled_components_1.useTheme();

  var themeStyles = __rest(utils_1.getComponentThemeStyles(theme, 'Tooltip', variant, size), []);

  var _g = React.useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }),
      reference = _g[0],
      setReference = _g[1];

  var _h = React.useState({
    width: 0,
    height: 0
  }),
      popoutBounds = _h[0],
      setPopoutBounds = _h[1];

  react_use_1.useClickAway(tooltipReferenceRef, function () {
    if (isClick && isVisibleByClick) {
      toggleClickVisible(false);
    }
  });
  var calcCenterOffset = popoutBounds.width / 2 - reference.width / 2;
  var calcYPos = reference.height + yOffset;

  var calcXPos = function calcXPos() {
    if (position === 'left' || position === 'right') {
      return reference.width;
    }

    return -calcCenterOffset - xOffset;
  };

  var componentType = isClick ? 'button' : 'div';

  var TriggerEle = function TriggerEle(hovered) {
    return React.createElement(TooltipReference, __assign({
      className: className,
      component: componentType,
      type: componentType
    }, isClick && {
      onClick: toggleClickVisible
    }, {
      isClick: isClick,
      tagRef: tooltipReferenceRef
    }), React.createElement(react_transition_group_1.Transition, {
      in: isClick ? isVisibleByClick : hovered,
      timeout: 200,
      mountOnEnter: true,
      unmountOnExit: true,
      appear: true
    }, function (state) {
      return React.createElement(TooltipPopout, {
        position: position,
        transitionState: state,
        ref: tooltipPopoutRef,
        xOffset: calcXPos(),
        yOffset: calcYPos,
        variant: variant,
        themeStyles: themeStyles
      }, children);
    }), trigger ? trigger : React.createElement(Icon, {
      size: ICON_SIZE
    }));
  };

  var _j = react_use_1.useHover(TriggerEle),
      hoverable = _j[0],
      hovered = _j[1];

  React.useEffect(function () {
    if (tooltipPopoutRef.current) {
      setPopoutBounds(tooltipPopoutRef.current.getBoundingClientRect());
    }

    setReference(tooltipReferenceRef.current.getBoundingClientRect());
  }, [hovered, isVisibleByClick, tooltipReferenceRef]);
  return hoverable;
}

exports.Tooltip = Tooltip;
var templateObject_1, templateObject_2, templateObject_3;